/*
 * A status badge for report mocks: colour plus word, never colour alone.
 * Synthetic data only.
 */
import { STATUS_LABELS, STATUS_TONE } from '../../mocks/sampleReport';

export function Status({ status }) {
  return <span className={`badge badge--${STATUS_TONE[status]}`}>{STATUS_LABELS[status]}</span>;
}
